import React from "react";

const CopyrightSocial = () => {
    const socialContent = [
        {
            id: 1,
            iconName: "fa-facebook-f",
            socialLink: "https://www.facebook.com/profile.php?id=100090733257387",
        },
        {
            id: 2,
            iconName: "fa-instagram",
            socialLink: "https://www.instagram.com/power_bizz/",
        },
        // {
        //     id: 3,
        //     iconName: "fa-whatsapp",
        //     socialLink: "https://web.whatsapp.com/",
        // },
        {
            id: 4,
            iconName: "fa-youtube",
            socialLink: "https://www.youtube.com/@Power_Bizz/featured",
        },
        {
            id: 5,
            iconName: "fa-tiktok",
            socialLink: "https://www.tiktok.com/@power_bizz",
        },
        {
            id: 6,
            iconName: "fa-linkedin",
            socialLink: "https://www.linkedin.com/company/power-bizz/",
        },
    ];

    return (
        <>
            {socialContent.map((social) => (
                <li key={social.id}>
                    <a href={social.socialLink} target="_blank" rel="noopener noreferrer">
                        <i className={`fab ${social.iconName}`}></i>
                    </a>
                </li>
            ))}
        </>
    );
};

export default CopyrightSocial;